import { useStakingView } from "./context/StakingViewContext";
import { ReadOnlyStake } from "./ReadOnlyStake";
import { StakingManager } from "./StakingManager";
import { NoStake } from "./NoStake";

export const Staking2: React.FC = () => {
  const { view } = useStakingView();

  switch (view) {
    case "ACTIVE":
      return <ReadOnlyStake />;

    case "ADJUSTING":
      return <StakingManager mode="stake" />;

    case "REDEEM":
      return <StakingManager mode="redeem" />;

    case "NONE":
      return <NoStake />;
  }
};
